import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import type { AccountMovement, MovementFormData } from "~/types/contabilidad";

import { MovimientoForm } from "./MovimientoForm";

interface MovimientoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  movement?: AccountMovement;
  onSubmit: (data: MovementFormData) => void;
  isLoading?: boolean;
  // Lock the Proveedores (AP, código 2103·) lines but keep the rest editable —
  // used for pago-a-proveedor drafts. The AP lines are owned by the subledger.
  lockApLines?: boolean;
}

export function MovimientoDialog({
  open,
  onOpenChange,
  movement,
  onSubmit,
  isLoading = false,
  lockApLines = false,
}: MovimientoDialogProps) {
  const isEditing = !!movement;

  const handleSubmit = (data: MovementFormData) => {
    onSubmit(data);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-2xl sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? "Editar Comprobante" : "Nuevo Comprobante"}
          </DialogTitle>
          <DialogDescription>
            {lockApLines
              ? "Edita la fecha, la referencia y las líneas adicionales. Las líneas de Proveedores están bloqueadas."
              : isEditing
                ? "Modifique los datos del comprobante."
                : "Complete los datos para crear un nuevo comprobante."}
          </DialogDescription>
        </DialogHeader>

        <MovimientoForm
          initialData={movement}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          submitLabel={isEditing ? "Actualizar" : "Crear Comprobante"}
          lockApLines={lockApLines}
        />
      </DialogContent>
    </Dialog>
  );
}
